export default {
    FormMaintenanceService: require('./FormMaintenanceService').default,
}